import Constant from '@/const';
import axios from 'axios';

const putGoods = async (id, payload) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/goods/${id}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putGoods;
